<div class="overflow-hidden rounded-xl border border-gray-100 bg-white shadow-sm">
  <div class="overflow-x-auto">
    <table class="w-full text-left rtl:text-right">
      <thead class="bg-gray-50/80 text-[12px] font-bold uppercase text-gray-400">
        <tr>
          <th class="px-6 py-4 w-16">#</th>
          <th class="px-6 py-4" i18n="@@subProduct.table.title">Title</th>
          <th class="px-6 py-4 text-center" i18n="@@subProduct.table.peoplePrice">People Price</th>
          <th class="px-6 py-4 text-center" i18n="@@subProduct.table.pharmacyPrice">Pharmacy Price</th>
          <th class="px-6 py-4 text-center" i18n="@@subProduct.table.sellerPrice">Seller Price</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100">
        @for (item of subProductsList(); track $index; let i = $index) {
          <tr class="transition-colors hover:bg-gray-50/30">
            
            <td class="px-6 py-4 text-[13px] font-medium text-gray-400">
              {{ i + 1 }}.
            </td>

            <td class="px-6 py-4">
              <span class="font-bold text-gray-800">
                {{ isArabic ? item.titleAr : item.titleEn }}
              </span>
            </td>

            <td class="px-6 py-4 text-center">
              <span class="font-bold text-gray-700">
                {{ item.customerPrice | number:'1.0-0' }} EGP
              </span>
            </td>

            <td class="px-6 py-4 text-center">
              <span class="font-bold text-gray-700">
                {{ item.pharmacyPrice | number:'1.0-0' }} EGP
              </span>
            </td>

            <td class="px-6 py-4 text-center">
              <span class="font-bold text-gray-700">
                {{ item.sellerPrice | number:'1.0-0' }} EGP
              </span>
            </td>

          </tr>
        } @empty {
          <tr>
            <td colspan="5" class="px-6 py-12 text-center">
              <span class="text-sm font-medium text-gray-400" i18n="@@subProduct.table.noData">
                No sub-products available
              </span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>